const cityTypes = ["город", "city", "місто", "kasaba", "şəhər"];

export default (settlementType, settlement) => {
	const cityValue = cityTypes.includes(settlementType)
		? settlement
		: `${settlementType} ${settlement}`;
	return cityValue;
};
